import { Controller } from '@hotwired/stimulus';
import {
  toCamelCase,
  transformObjectKeys,
} from '@inked/utilities';
import Mustache from 'mustache';

export class MediaSwapController extends Controller {
  static targets = [
    'input',
    'media',
    'template',
  ];
  static values = {
    defaultKey: {
      default: '*',
      type: String,
    },
    files: Object,
  };

  processFilesObject(files = {}, fallback = {}) {
    return Object.fromEntries(Object.entries(
      transformObjectKeys(
        {
          ...fallback,
          ...Object.fromEntries(Object.entries(files).filter(([ , value ]) => {
            if (!value) return false;
            if (Array.isArray(value)) return value.length > 0;

            return true;
          })),
        },
        toCamelCase
      )
    ).map(([ key, value ]) => [
      key,
      Array.isArray(value)
        ? value.map((item, index) => ({
          index,
          // FIXME: workaround for videos not being included in product media dialog
          indexWithoutVideo: value.filter(item => !item.isVideo).findIndex(filteredItem => filteredItem === item),
          position: index + 1,
          ...item,
        }))
        : value
    ]));
  }

  setFiles(files) {
    this.mediaTargets.forEach((media, index) => {
      const template = this.templateTargets[index] || this.templateTarget;

      media.innerHTML = Mustache.render(template.innerHTML, files);

      media.querySelectorAll('img[data-src]').forEach(img => img.src = img.dataset.src);
      media.querySelectorAll('img[data-srcset]').forEach(img => img.srcset = img.dataset.srcset);
      media.querySelectorAll('source[data-srcset]').forEach(source => source.srcset = source.dataset.srcset);
      media.querySelectorAll('video[data-poster]').forEach(video => video.poster = video.dataset.poster);
      media.querySelectorAll('video[data-src]').forEach(video => video.src = video.dataset.src);
    });
  }

  swap(event) {
    const selected = this.filesValue[event.target.value];
    const fallback = this.filesValue[this.defaultKeyValue];

    const files = this.processFilesObject(selected, fallback);

    this.setFiles(files);
  }
}
